import { PriceDetails } from '../PriceDetails/PriceDetails';
import { PromoCode } from '../PromoCode/PromoCode';
import { PurchasedItems } from '../PurchasedItems/PurchasedItems';

export const DetailsWrapper = () => {
  return (
    <div className="flex flex-col w-full">
      <PurchasedItems />
      <PromoCode />
      <PriceDetails />
    </div>
  );
};
